import { lazy } from "react";

import { SettingsPaths } from "Pages/settings/paths";

import BrandSecretsPage from "./BrandSecretsPage";
import { BrandSecretsPaths } from "./BrandSecretsPaths";

import type { RegalRouteObject } from "App/routes/types";

const SecretsListPage = lazy(() => import("./Pages/SecretsListPage"));
const CreateSecretPage = lazy(() => import("./Pages/CreateSecretPage"));
const EditSecretPage = lazy(() => import("./Pages/EditSecretPage"));

export const brandSecretsRoute: RegalRouteObject = {
    path: SettingsPaths.brandSecrets,
    element: <BrandSecretsPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <SecretsListPage />,
        },
        {
            path: BrandSecretsPaths.create,
            element: <CreateSecretPage />,
        },
        {
            path: BrandSecretsPaths.edit,
            element: <EditSecretPage />,
        },
    ],
};
